import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext({ email: null, loading: true, login: async () => {}, logout: () => {} });

export function AuthProvider({ children }) {
    const [email, setEmail] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("cp_token");
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((res) => setEmail(res.data.email))
            .catch(() => localStorage.removeItem("cp_token"))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const res = await api.post("/auth/login", { email, password });
        localStorage.setItem("cp_token", res.data.access_token);
        setEmail(res.data.email);
        return res.data;
    };

    const logout = () => {
        localStorage.removeItem("cp_token");
        setEmail(null);
    };

    return (
        <AuthContext.Provider value={{ email, loading, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
